export const ROUTE_NAMES = {
  landing: 'landing',
  inspect: 'inspect',
  synthesis: 'synthesis',
  onboarding: 'onboarding',
  advisorPatrimony: 'advisor-patrimony',
  advisorSituation: 'advisor-situation',
  advisorBudget: 'advisor-budget',
  customerQualification: {
    base: 'customer-qualification-budget',
    survey: 'survey',
    summary: 'summary',
  },
  retirement: 'retirement',
  situation: 'situation',
  dmp: 'patrimony-development',
  protection: 'protection',
  reallocation: 'reallocation',
  advisingReportPdf: 'AdvisingReportPdf',
  patrimony: {
    index: 'patrimony',
    add: 'patrimonyAdd',
    aggregationManager: 'AggregationManager',
    aggregation: 'Aggregation',
    aggregationAdd: 'AggregationAdd',
    aggregationSelection: 'AggregationSelection',
    estimation: 'Estimation',
    estimationAmount: 'EstimationAmount',
    loan: 'patrimonyLoan',
    total: 'MonPatrimoineTotal',
    portfolio: {
      preview: 'PatrimonyPortfolioPreview',
      estimation: 'PatrimonyPortfolioEstimation',
      repartition: 'PatrimonyPortfolioRepartition',
      details: 'patrimonyPortfolioDetails',
      investments: 'PatrimonyPortfolioInvestments',
      esg: 'PatrimonyPortfolioESG',
    },
  },
  budget: 'budget',
  advisorRiskProfile: 'advisor-risk-profile',
  endOfCircuit: 'endOfCircuit',
  taxation: {
    details: {
      main: 'main',
    },
    taxReturn: {
      balance: 'balance',
      civilStatus: {
        civilStatus: 'civilStatus',
        taxSituation: 'tax-situation',
        dependantPersons: 'dependantPersons',
        connectedPersons: 'connectedPersons',
        address: 'address',
        bankDetails: 'bankDetails',
      },
      withholdingTax: 'withholdingTax',
      businessIncome: {
        businessIncome: 'businessIncome',
        wages: 'wages',
        exemptIncome: 'exemptIncome',
        pensions: 'pensions',
        selfEmployedWorkers: 'selfEmployedWorkers',
      },
    },
    update: 'taxationUpdate',
  },
  taxationCircuit: {
    taxationPagesContainer: 'taxationPagesContainer',
  },
  transmissionCircuit: {
    transmissionPagesContainer: 'transmissionPagesContainer',
  },
  minorCircuit: {
    minorPagesContainer: 'minorPagesContainer',
  },
  dmpCircuit: {
    dmpPagesContainer: 'dmpPagesContainer',
  },
  appointments: {
    index: 'appointments',
    add: 'add-appointment',
    success: 'success',
  },
  shortCircuit: 'shortCircuit',
  shortCircuitSteps: {
    chooseOperation: 'chooseOperation',
    configuration: 'configuration',
    financialPivot: 'financialPivot',
    productSelection: 'productSelection',
  },
} as const

export type TRouteNames = typeof ROUTE_NAMES
export type TRouteValues = ValueOf<typeof ROUTE_NAMES>

type TPatrimonyRouteNames = TRouteNames['patrimony']
type TPatrimonyPortfolioRouteNames = TPatrimonyRouteNames['portfolio']

export type AllPatrimonyRouteNames =
  | TPatrimonyRouteNames[Exclude<keyof TPatrimonyRouteNames, 'portfolio'>]
  | TPatrimonyPortfolioRouteNames[keyof TPatrimonyPortfolioRouteNames]

export const shortCircuitPath = '/short-circuit'
